import React from 'react';
import { styled } from '@compiled/react';
import noop from 'lodash/noop';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages.tsx';

type Props = {
	isDeleteEnabled: boolean;
	isDeleteInProgress: boolean;
} & Intl & {
		onCancel: () => void;
		onDelete: () => void;
	};

export function Footer(props: Props): React.JSX.Element {
	const {
		intl: { formatMessage },
		onCancel,
		onDelete,
		isDeleteEnabled,
		isDeleteInProgress,
	} = props;

	return (
		<ButtonsContainer>
			{isDeleteInProgress && (
				<Box xcss={spinnerContainerStyles}>
					<Spinner size="small" />
				</Box>
			)}
			<Button
				appearance="warning"
				isDisabled={!isDeleteEnabled || isDeleteInProgress}
				onClick={onDelete}
			>
				{formatMessage(messages.delete)}
			</Button>
			<Button appearance="subtle-link" onClick={onCancel}>
				{formatMessage(messages.cancel)}
			</Button>
		</ButtonsContainer>
	);
}

Footer.defaultProps = {
	isDeleteEnabled: true,
	isDeleteInProgress: false,
	onCancel: noop,
	onDelete: noop,
};

export default withFireUiAnalytics({
	onCancel: 'cancel',
	onDelete: 'delete',
})(injectIntl(Footer));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonsContainer = styled.div({
	display: 'flex',
	justifyContent: 'flex-end',
	alignItems: 'center',
	width: '100%',
});

const spinnerContainerStyles = xcss({
	marginRight: 'space.200',
});
